.card-background{display:block;width:100%;border-radius:25px;height:461px;object-fit:cover}
/*# sourceMappingURL=about-us.page-KVQZ77N2.css.map */
